module.exports = __webpack_public_path__ + "static/img/banner-cursos-768x1024.16ab684.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-768x1024.jpg
// module id = uM0U
// module chunks = 47